module.exports = __webpack_public_path__ + "static/media/edu_kitchen.667e5a1e.webp";